import React, { useState, useEffect } from "react";
import { PieChart, Pie, Cell, Tooltip, Legend, ResponsiveContainer, Label } from 'recharts';

function OverallPlanStatuses() {
    
  const [chartData, setChartData] = useState([]);

  useEffect(() => {
    fetch('https://malaria-api.ddc-malaria.org/mhealth/getChartOverallPlanStatusesToday/fs_year')
      .then(response => response.json())
      .then(data => {
        // Transform the API data to match Recharts' expected format
        const transformedData = Object.entries(data.overall_plan_statuses)
          .filter(([key]) => key !== "total_plan")
          //.map(([name, value]) => ({ name, value: parseInt(value, 10) })); 
          .map(([name, value]) => ({ 
            name: {
              "total_cancel": "Cancel",
              "total_draft": "Draft",
              "total_processing": "Processing",
              "total_expire": "Expire",
              "total_done": "Done"
            }[name] || name, // Use the mapping or keep the original name if not found
            value: parseInt(value, 10) 
          })); 
        setChartData(transformedData);
      })
      .catch(error => console.error("Error fetching data:", error));
  }, []);
  


  const COLORS = ["#FF0000","#0088FE", "#00C49F", "#FFBB28", "#008000"];

  const CustomTooltip = ({ active, payload, label }) => {
    if (active && payload && payload.length) {
      return (
        <div className="custom-tooltip">
          <p className="label">{`${payload[0].name} : ${payload[0].value}`}</p>
          <p className="desc">{`${(payload[0].value / chartData.reduce((sum, entry) => sum + entry.value, 0) * 100).toFixed(2)}%`}</p>
        </div>
      );
    }

    return null;
  };

  const totalValue = chartData.reduce((sum, entry) => sum + entry.value, 0);

  return (
    <div className="overall-plan-statuses">
      <h3>Overall Plan Statuses</h3>
      <ResponsiveContainer width="100%" height={300}>
        <PieChart>
          <Pie
            data={chartData}
            cx="50%"
            cy="50%"
            innerRadius={40} // Adjust this for the hole size
            outerRadius={80}
            fill="#8884d8"
            dataKey="value"
            labelLine={false}
          >
            {chartData.map((entry, index) => (
              <Cell key={`cell-${index}`} fill={COLORS[index % COLORS.length]} />
            ))}

            {/* Center Label for Total */}
            <Label
              value={totalValue}
              position="center"
              fill="#000"
              fontSize={18}
              fontWeight="bold"
            />
            <Label 
                value="Total"
                position="center"
                dy={20} // Adjust this value to control vertical spacing 
                fill="#000"
                fontSize={14} // You might want a smaller font size for the text
            />
          </Pie>
          <Tooltip content={<CustomTooltip />} />
          <Legend iconType="circle" layout="vertical" verticalAlign="middle" align="left"  wrapperStyle={{
            padding: 10, 
            border: "0px solid #ccc", 
    }}/>
          
        </PieChart>
      </ResponsiveContainer>
    </div>
  );
}

export default OverallPlanStatuses;
